<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.complianceaudit"
				:id="id"
				:models="models"
				:infos="infos"
				topClass=""
			></show>

			<!-- Stato audit -->
			<v-card v-if="audit" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Stato audit</p>
					<v-spacer></v-spacer>
					<v-btn text color="info" small :loading="pdfLoading" @click="downloadPdf"><v-icon left small>mdi-file-pdf-box</v-icon> Rapporto PDF</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<div class="d-flex align-center flex-wrap">
						<span class="mr-3">Stato attuale:</span>
						<v-chip :color="statusMeta(audit.status).color" dark label class="mr-4">
							<v-icon left small>{{ statusMeta(audit.status).icon }}</v-icon>
							{{ statusMeta(audit.status).text }}
						</v-chip>
						<v-spacer></v-spacer>
						<v-btn v-for="t in audit.available_transitions" :key="t" small class="ml-2 mb-1"
							:color="statusMeta(t).color" dark @click="transition(t)">
							<v-icon left small>{{ statusMeta(t).icon }}</v-icon>
							{{ statusMeta(t).text }}
						</v-btn>
					</div>
				</v-card-text>
			</v-card>

			<!-- Checklist rilievi -->
			<v-card v-if="audit" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Rilievi (checklist)</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openFindingDialog">
						<v-icon left small>mdi-plus</v-icon> Aggiungi rilievo
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-0">
					<v-simple-table v-if="audit.findings && audit.findings.length" class="background-2">
						<thead>
							<tr>
								<th>Requisito</th>
								<th>Esito</th>
								<th>Descrizione</th>
								<th class="text-right">Azioni</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="f in audit.findings" :key="f.id">
								<td>{{ f.requirement ? f.requirement.clause + ' — ' + f.requirement.title : '—' }}</td>
								<td><v-chip x-small dark :color="resultColor(f.result)" label>{{ f.result_text || f.result }}</v-chip></td>
								<td class="grey--text">{{ f.description }}</td>
								<td class="text-right" style="white-space:nowrap">
									<v-btn v-if="f.nonconformity_id" text x-small color="success"
										@click="$router.push({ name: 'compliancenonconformities-show', params: { id: f.nonconformity_id } })">
										<v-icon x-small left>mdi-link-variant</v-icon> NC #{{ f.nonconformity_id }}
									</v-btn>
									<v-btn v-else-if="isNc(f.result)" text x-small color="error" :loading="ncLoading === f.id" @click="generateNc(f)">
										<v-icon x-small left>mdi-alert-octagon</v-icon> Genera NC
									</v-btn>
									<v-btn icon x-small color="grey" @click="deleteFinding(f)"><v-icon x-small>mdi-trash-can-outline</v-icon></v-btn>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
					<div v-else class="pa-4 grey--text text-center">Nessun rilievo registrato</div>
				</v-card-text>
			</v-card>

			<dms-uploader class="mt-4" :id="id" attachable-type="complianceaudit"></dms-uploader>

			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn v-on="{ ...tooltip }" @click.native="$eventBusUtility.goTo($router, 'complianceaudits-edit', id)"
							color="primary" dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<!-- Dialog nuovo rilievo -->
			<v-dialog v-model="findingDialog" max-width="640" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Nuovo rilievo</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="finding.requirement_id" :items="requirementOptions" item-text="label" item-value="value"
							label="Requisito / controllo" outlined dense clearable :menu-props="{'offset-y': true}" prepend-icon="mdi-format-list-checks"></v-autocomplete>
						<v-select v-model="finding.result" :items="resultOptions" item-text="text" item-value="value"
							label="Esito" outlined dense :menu-props="{'offset-y': true}" prepend-icon="mdi-clipboard-check"></v-select>
						<v-textarea v-model="finding.description" label="Descrizione" outlined rows="2" auto-grow prepend-icon="mdi-text"></v-textarea>
						<v-textarea v-model="finding.evidence" label="Evidenza" outlined rows="2" auto-grow prepend-icon="mdi-file-search"></v-textarea>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="findingDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="savingFinding" :disabled="!finding.result" @click="saveFinding">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceAudit',

	props: { id: Number },

	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			findingDialog: false,
			savingFinding: false,
			pdfLoading: false,
			ncLoading: null,
			finding: { requirement_id: null, result: null, description: '', evidence: '' },
			requirementOptions: [],
			resultOptions: [
				{ value: 'conforme', text: 'Conforme' },
				{ value: 'nc_maggiore', text: 'NC Maggiore' },
				{ value: 'nc_minore', text: 'NC Minore' },
				{ value: 'osservazione', text: 'Osservazione' },
				{ value: 'raccomandazione', text: 'Raccomandazione' },
				{ value: 'na', text: 'Non applicabile' }
			],
			statusMap: {
				pianificato: { text: 'Pianificato', color: '#9e9e9e', icon: 'mdi-calendar-clock' },
				in_corso:    { text: 'In corso',    color: '#ff9800', icon: 'mdi-progress-check' },
				completato:  { text: 'Completato',  color: '#03a9f4', icon: 'mdi-clipboard-check' },
				chiuso:      { text: 'Chiuso',      color: '#4caf50', icon: 'mdi-lock-check' }
			}
		}
	},

	computed: {
		audit() { return this.models.complianceaudit }
	},

	created() { this.load() },

	methods: {
		load() {
			this.loading = true
			this.axios.get('complianceaudits/' + this.id).then(response => {
				this.models = response.data.models
				this.infos = response.data.infos
				this.loading = false
			}, () => {
				this.loading = false
				this.$store.commit('setSnackbarError')
			})
		},
		statusMeta(status) {
			return this.statusMap[status] || { text: status, color: 'grey', icon: 'mdi-help-circle' }
		},
		downloadPdf() {
			this.pdfLoading = true
			this.axios.get('complianceaudits/' + this.id + '/pdf', { responseType: 'blob' }).then(r => {
				this.pdfLoading = false
				const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
				const a = document.createElement('a')
				a.href = url
				a.download = 'Audit-' + (this.audit.code || this.id) + '.pdf'
				document.body.appendChild(a)
				a.click()
				a.remove()
				window.URL.revokeObjectURL(url)
			}, () => { this.pdfLoading = false; this.$store.commit('setSnackbarError') })
		},
		isNc(result) {
			return result === 'nc_maggiore' || result === 'nc_minore'
		},
		resultColor(result) {
			const map = { conforme: '#4caf50', nc_maggiore: '#f44336', nc_minore: '#ff5722', osservazione: '#ff9800', raccomandazione: '#2196f3', na: '#9e9e9e' }
			return map[result] || 'grey'
		},
		transition(target) {
			this.axios.post('complianceaudits/' + this.id + '/transition', { status: target }).then(() => {
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Stato aggiornato', timeout: 4000 })
				this.load()
			}, error => {
				const msg = error.response && error.response.data ? error.response.data.message : 'Errore nel cambio di stato'
				this.$store.commit('setSnackbar', { value: true, color: 'error', text: msg, timeout: 6000 })
			})
		},
		openFindingDialog() {
			this.finding = { requirement_id: null, result: null, description: '', evidence: '' }
			if (!this.requirementOptions.length) this.loadRequirementOptions()
			this.findingDialog = true
		},
		loadRequirementOptions() {
			this.axios.get('compliance-requirements-options').then(r => {
				this.requirementOptions = r.data.data.map(x => ({ value: x.value, label: x.text }))
			})
		},
		saveFinding() {
			this.savingFinding = true
			this.axios.post('complianceaudits/' + this.id + '/findings', this.finding).then(() => {
				this.savingFinding = false
				this.findingDialog = false
				this.load()
			}, () => {
				this.savingFinding = false
				this.$store.commit('setSnackbarError')
			})
		},
		deleteFinding(f) {
			this.axios.post('complianceaudits/' + this.id + '/findings/' + f.id + '/delete').then(() => this.load(), () => this.$store.commit('setSnackbarError'))
		},
		generateNc(f) {
			this.ncLoading = f.id
			this.axios.post('complianceaudits/' + this.id + '/findings/' + f.id + '/generate-nc').then(() => {
				this.ncLoading = null
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Non conformità generata', timeout: 4000 })
				this.load()
			}, error => {
				this.ncLoading = null
				const msg = error.response && error.response.data ? error.response.data.message : 'Errore'
				this.$store.commit('setSnackbar', { value: true, color: 'error', text: msg, timeout: 6000 })
			})
		}
	}
}
</script>
